import { render, staticRenderFns } from "./CuentaDeCliente.vue?vue&type=template&id=47485f09"
import script from "./CuentaDeCliente.vue?vue&type=script&lang=js"
export * from "./CuentaDeCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports